module.exports = __webpack_public_path__ + "static/img/icon_help.31f848d7.png";